import { useQuery } from '@tanstack/react-query'
import { useAccessToken, useCurrentUser } from '@/features/auth/state/auth'

import api from '@/lib/api'

interface Options {
  enabled: boolean
}

export function useFetchClientsByTenantList(id_tenant?: string | null, options?: Options) {
  const user = useCurrentUser()
  const token = useAccessToken()

  return useQuery({
    queryKey: ['clients', id_tenant],
    queryFn: async () => {
      if (!user || !token) throw new Error('Usuário ou token ausente')
      if (!id_tenant) throw new Error('ID da empreasa é obrigatório')

      const response = await api.get(`/clients/tenant/${id_tenant}`, {
        headers: { Authorization: `Bearer ${token}` }
      })

      if (response.data && Array.isArray(response.data.data)) {
        return response.data.data.map((client: any) => ({
          id_client: client.cnpjcpf,
          cnpjcpf: client.cnpjcpf,
          razao_social: client.razao_social,
          id_responsavel: client.id_responsavel,
          id_gerente: client.id_gerente,
          id_tenant: client.id_tenant,
          id_owner: client.id_owner,
          status: client.status,
          nomeProprietario: client.nomeProprietario ?? client.owner?.nomeProprietario ?? null,
          cpfProprietario: client.cpfProprietario ?? client.owner?.cpfProprietario ?? null,
          verifiedOwner: client.verifiedOwner ?? client.owner?.verifiedOwner ?? null,
          owner: client.owner ?? null
        }))
      } else {
        throw new Error('Estrutura de resposta inesperada ao buscar clientes')
      }
    },
    enabled: Boolean(user && token && id_tenant && options?.enabled)
  })
}
